angular
        .module('core.values', [])
        .value('apiToken',{token:null});
